module.exports = __webpack_public_path__ + "static/logo-culture-5d8b0f260baaff032a9c63daab01ad3b.png";